import { VipButton } from '@3ddv/ngx-sites-builder-lib';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { VipinfoEditPopupModalComponent } from './components/vipinfo-edit-popup-modal/vipinfo-edit-popup-modal.component';
import { VWVipButton } from '../../models/vipinfo.model';
import { VipDefaultButton } from '@3ddv/ngx-sites-builder-lib/lib/workflows/interface/vipinfo/models/vipinfo.model';

@Component({
  selector: 'app-vipinfo-modal',
  templateUrl: './vipinfo-modal.component.html',
})
export class VipinfoModalComponent implements OnInit {
  @Input() vipInfoButton: VWVipButton;
  @Output() save: EventEmitter<VWVipButton>;
  @Output() delete: EventEmitter<string>;
  @Output() cancel: EventEmitter<void>;

  public vipInfoButtonCopy: VWVipButton;

  ngOnInit(): void {
    this.vipInfoButtonCopy = JSON.parse(JSON.stringify(this.vipInfoButton));
  }
  constructor(
    private _modalService: BsModalService, // service provided by bootstrap to display a modal
    private _bsModalRef: BsModalRef // service to handle data from modal to parent
  ) {
    // initialize variables
    this.save = new EventEmitter<VWVipButton>();
    this.delete = new EventEmitter<string>();
    this.cancel = new EventEmitter<void>();
  }
  onSave(): void {
    this.save.emit(this.vipInfoButtonCopy);
  }
  // function to trigger the cancel event
  onCancel(): void {
    this.cancel.emit();
  }
  // function to trigger the delete event
  onDelete(): void {
    this.delete.emit(this.vipInfoButtonCopy.id);
  }

  // function to open the modal to edit the popup content
  openModal(): void {
    const initialState = {
      popupContent: (this.vipInfoButton as VipDefaultButton).config.popupContent,
    };

    this._bsModalRef = this._modalService.show(VipinfoEditPopupModalComponent, { initialState, animated: false });
    // when the popup content is saved though the modal, save the updated content
    this._bsModalRef.content.save.subscribe((updatedPopupContent: string) => {
      // hide the modal
      this._bsModalRef.hide();
      // updated the popup content
      (this.vipInfoButtonCopy as VipDefaultButton).config.popupContent = updatedPopupContent;
    });
    // hide the poupu when canceled
    this._bsModalRef.content.cancel.subscribe(() => {
      // hide the modal
      this._bsModalRef.hide();
    });
  }
}
